<div class="header" *ngIf="showHeader">
    <span class="title">{{ 'WORKFLOWS.RUNNER.UPLOAD_FILES' | translate }}</span>
    <button type="button" *ngIf="!isDisabled" class="btn btn-secondary" (click)="resetFileUploader()">
        {{ 'WORKFLOWS.RUNNER.RESET' | translate }}
    </button>
</div>
<div
    *ngIf="!isDisabled"
    class="upload-area d-flex justify-content-center"
    caApeerFileUpload
    data-uit="file-upload"
    [ngClass]="getUploaderCssClasses()"
    [uploaderKey]="uploaderKey"
    [maxInputSizeInBytes]="maxInputSizeInBytes"
    [showGeneralMaxInputSizeMessage]="showGeneralMaxInputSizeMessage"
    [supportedFileTypes]="supportedFileTypes"
    [notSupportedFileTypeCustomMessage]="notSupportedFileTypeCustomMessage"
    [blobType]="blobType"
    [pathToAppend]="pathToAppend"
    [base64StringToUpload]="base64StringToUpload"
    [targetFolderId]="targetFolderId"
    [createTargetFolder]="createTargetFolder"
    [datasetId]="datasetId"
    [datasetFileType]="datasetFileType"
    [allowSameFileNames]="allowSameFileNames"
    [uploadValidationSelectedFiles]="uploadValidationSelectedFiles"
    [cancelUpload]="cancelUpload"
    [cancelAllUploads]="cancelAllUploads"
    [errorNotificationMode]="errorNotificationMode"
    (fileOver)="fileOverBase($event)"
    (onReset)="resetFileUploader()"
    (onFilesAdded)="filesAdded($event)"
    (onUploadStarted)="uploadStarted($event)"
    (onUploadCompleted)="uploadCompleted($event)"
    (onAllUploadsCompleted)="allUploadsCompleted()"
    (onFileCreated)="fileCreated($event)"
    (onUploadRemoved)="uploadRemoved($event)"
    (invalidFiles)="invalidFiles.emit($event)"
    data-uit="file-upload"
>
    <!-- Loader: Shown before _uploader is ready -->
    <div *ngIf="isLoading()" class="w-100 loading-area d-flex flex-column justify-content-center align-items-center">
        <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
        {{ 'WORKFLOWS.RUNNER.LOADING_DATA' | translate }}
    </div>
    <div *ngIf="!isLoading() && !isSmallDevice" class="drop-zone w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-center">
        <div class="d-flex flex-column align-items-center mb-2">
            <ca-icon name="upload" size="m" class="mb-3"></ca-icon>
            <h4 class="file-name">{{ 'WORKFLOWS.RUNNER.DRAG_AND_DROP_INPUT_FILES' | translate }}</h4>
        </div>
        <div>
            <button type="button" class="btn btn-primary" data-uit="file-upload-btn" (click)="uploadSection.click()">
                {{ 'WORKFLOWS.RUNNER.BROWSE' | translate }}
                <input #uploadSection type="file" data-uit="file-upload-input" ng2FileSelect [uploader]="uploader" [multiple]="allowMultipleFiles" hidden />
            </button>
        </div>
    </div>
    <div *ngIf="!isLoading() && isSmallDevice">
        <button type="button" class="btn btn-primary" data-uit="file-upload-btn" (click)="uploadSection.click()">
            {{ 'WORKFLOWS.RUNNER.BROWSE_DEVISE' | translate }}
            <input #uploadSection type="file" data-uit="file-upload-input" ng2FileSelect [uploader]="uploader" [multiple]="allowMultipleFiles" hidden />
        </button>
    </div>
</div>
<ca-files-upload-progress *ngIf="uploader?.queue?.length > 0" [uploader]="uploader" (cancelFileUpload)="cancelFileUpload($event)"></ca-files-upload-progress>
